module.exports = __webpack_public_path__ + "media/images/frontend/about_second-60faf805729046f6901e77dd9af849d2.webp";